export interface Tenant {
    id: string;
    key?: string;
    name: string;
    logoUrl?: string | null;
    logoBlobId?: string | null;
}

export function tenantLogoUrl(value: string | null | undefined): string | null {
    const trimmed = value?.trim();
    if (!trimmed || trimmed.length > 2048 || !/^https:\/\//i.test(trimmed) || /[\u0000-\u001f\u007f]/.test(trimmed)) return null;
    try {
        const url = new URL(trimmed);
        return url.hostname && !url.username && !url.password && url.href.length <= 2048 ? url.href : null;
    } catch {
        return null;
    }
}
